/* eslint-disable array-callback-return */
import { Component } from "react";
import { Link } from "react-router-dom";
import { JJ_Icon_Chevron_right, JJ_Icon_Chevron_down } from "../../assets";
import ApiServices from "../../utils/apiServices";
import config from "../../config/config";
import trackingService from "../../services/trackingService";
import "../ContentShortcuts/ContentShortcuts.css";

// const convertToHtml = (data) => {
//   return <div dangerouslySetInnerHTML={{ __html: data }}></div>;
// };

class AdministrationAndDosagesGenAIRec extends Component {
    constructor(props) {
        super(props);
        this.service = new ApiServices();
        this.state = {
            showCSModal: false,
            showInfo: false,
            products: props.products,
            arrayOfDocTypes: [],
            selectedDosageType: [],
            selectedProduct: props.selectedProduct,
            startIndex: 0,
            isSelectedProduct: false,
            showContentDosage: false,
            showContentDocumentType: false,
            dosageType: [],
            selectedDefault: "",
            selectedDosage: "",
            showDocsType: false,
            showNote: true,
        };
    }
    async componentDidMount() {
        this.setState({
            arrayOfDocTypes: config.routesofAandD,
            products: this.props.products,
            selectedProduct: this.props.selectedProduct,
        }, async () => {
            if (this.props.selectedProduct) {

                let dosagesVal = await this.service.getDosagesforProduct(
                    this.state.selectedProduct
                );
                if (dosagesVal?.length > 0) {
                    if (
                        dosagesVal
                            .map((x) => x.dosagetype)
                            .every((val, i, arr) => val === arr[0])
                    ) {
                        let dosType = dosagesVal.map((x) => x.dosagetype);
                        const x = this.eliminateDuplicates(dosType);
                        this.setState({ selectedDosageType: x });
                    }
                    this.setState({ dosageType: dosagesVal });
                }

            }
        });
    }

    componentWillReceiveProps() {
        if (this.props.products?.length !== this.state.products.length) {
            if (
                this.props.products?.length > 0 &&
                this.props.selectedProduct.length > 0
            ) {
                this.setState(
                    {
                        products: this.props.products,
                        selectedProduct: this.props.selectedProduct,
                    },
                    async () => {
                        let dosagesVal = await this.service.getDosagesforProduct(
                            this.state.selectedProduct
                        );
                        if (dosagesVal?.length > 0) {
                            if (
                                dosagesVal
                                    .map((x) => x.dosagetype)
                                    .every((val, i, arr) => val === arr[0])
                            ) {
                                let dosType = dosagesVal.map((x) => x.dosagetype);
                                const x = this.eliminateDuplicates(dosType);
                                this.setState({ selectedDosageType: x });
                            }
                            this.setState({ dosageType: dosagesVal });
                        }
                    }
                );
            }
        }
    }

    componentDidUpdate = () => {
        if (this.props.showCRPCSModal !== this.state.showCSModal) {
            this.setState({ showCSModal: this.props.showCRPCSModal });
        }
    };

    eliminateDuplicates = (arr) => {
        var i,
            len = arr.length,
            out = [],
            obj = {};

        for (i = 0; i < len; i++) {
            obj[arr[i]] = 0;
        }
        for (i in obj) {
            out.push(i);
        }
        return out;
    };

    handleSelectProduct = (event) => {
        event.preventDefault();
        if (event) {
            this.setState(
                {
                    selectedProduct: event.target.value,
                },
                async () => {
                    let dosagesVal = await this.service.getDosagesforProduct(
                        this.state.selectedProduct
                    );
                    let dosType = dosagesVal.map((x) => x.dosagetype);
                    const x = this.eliminateDuplicates(dosType);
                    this.setState({ selectedDosageType: x });
                    this.setState({ dosageType: dosagesVal, showDocsType: false, selectedDosage: "" });
                }
            );
        }
        this.setState({
            showContentDosage: false,
        })
    };

    productOptionListing = () => {
        let { products } = this.state
        return (
            <>
                {(products && products.length > 0) && products.map((item, index) => {
                    return (
                        <option
                            key={index}
                            id={`${item}`}
                        >
                            {item}
                        </option>
                    );
                })}
            </>
        )
    }


    generateListofDosageType = (arrayOfDosage, i) => {
        if (arrayOfDosage.length > 0) {
            if (this.state.selectedDosageType.length > 0) {
                if (i === 0) {
                    return arrayOfDosage
                        .filter(
                            (val) => val.dosagetype === this.state.selectedDosageType[0]
                        )
                        .map((items, index) => {
                            return (
                                <div key={index} className="gen-ai-ims-home-dosagesSelection">
                                    <input
                                        type="radio"
                                        id={`${items.dosage}`}
                                        className="gen-ai-ims-home-content-k-radio popoverAvoidClickOutside"
                                        value={items.dosage}
                                        name="dosageRadioButton"
                                        key={items.dosage + Math.random()}
                                        onChange={this.handleChangeInDosageType}
                                        checked={this.state.selectedDosage === items.dosage}
                                    />
                                    <span className="gen-ai-ims-home-dosagesText">{items.dosage}</span>
                                </div>
                            );
                        });
                }
                if (i === 1) {
                    return arrayOfDosage
                        .filter(
                            (val) => val.dosagetype === this.state.selectedDosageType[1]
                        )
                        .map((items, index) => {
                            return (
                                <div key={index} className="gen-ai-ims-home-dosagesSelection">
                                    <input
                                        type="radio"
                                        id={`${items.dosage}`}
                                        className="gen-ai-ims-home-content-k-radio popoverAvoidClickOutside"
                                        value={items.dosage}
                                        name="dosageRadioButton"
                                        key={items.dosage + Math.random()}
                                        onChange={this.handleChangeInDosageType}
                                        checked={this.state.selectedDosage === items.dosage}
                                    />
                                    <div className="gen-ai-ims-home-dosagesText">{items.dosage}</div>
                                </div>
                            );
                        });
                }
                if (i === 2) {
                    return arrayOfDosage
                        .filter(
                            (val) => val.dosagetype === this.state.selectedDosageType[1]
                        )
                        .map((items, index) => {
                            return (
                                <div key={index} className="gen-ai-ims-home-dosagesSelection">
                                    <input
                                        type="radio"
                                        id={`${items.dosage}`}
                                        class="k-radio"
                                        value={items.dosage}
                                        name="dosageRadioButton"
                                        className="gen-ai-ims-home-content-k-radio popoverAvoidClickOutside"
                                        key={items.dosage + Math.random()}
                                        onChange={this.handleChangeInDosageType}
                                        checked={this.state.selectedDosage === items.dosage}
                                    />
                                    <div className="gen-ai-ims-home-dosagesText">{items.dosage}</div>
                                </div>
                            );
                        });
                }
                if (i === 3) {
                    return arrayOfDosage
                        .filter(
                            (val) => val.dosagetype === this.state.selectedDosageType[1]
                        )
                        .map((items, index) => {
                            return (
                                <div key={index} className="gen-ai-ims-home-dosagesSelection">
                                    <input
                                        type="radio"
                                        id={`${items.dosage}`}
                                        class="k-radio"
                                        value={items.dosage}
                                        name="dosageRadioButton"
                                        className="gen-ai-ims-home-content-k-radio popoverAvoidClickOutside"
                                        key={items.dosage + Math.random()}
                                        onChange={this.handleChangeInDosageType}
                                        checked={this.state.selectedDosage === items.dosage}
                                    />
                                    <div className="gen-ai-ims-home-dosagesText">{items.dosage}</div>
                                </div>
                            );
                        });
                }
                if (i === 4) {
                    return arrayOfDosage
                        .filter(
                            (val) => val.dosagetype === this.state.selectedDosageType[1]
                        )
                        .map((items, index) => {
                            return (
                                <div key={index} className="gen-ai-ims-home-dosagesSelection">
                                    <input
                                        type="radio"
                                        id={`${items.dosage}`}
                                        class="k-radio"
                                        value={items.dosage}
                                        name="dosageRadioButton"
                                        className="gen-ai-ims-home-content-k-radio popoverAvoidClickOutside"
                                        key={items.dosage + Math.random()}
                                        onChange={this.handleChangeInDosageType}
                                        checked={this.state.selectedDosage === items.dosage}
                                    />
                                    <div className="gen-ai-ims-home-dosagesText">{items.dosage}</div>
                                </div>
                            );
                        });
                }
                if (i === 5) {
                    return arrayOfDosage
                        .filter(
                            (val) => val.dosagetype === this.state.selectedDosageType[1]
                        )
                        .map((items, index) => {
                            return (
                                <div key={index} className="gen-ai-ims-home-dosagesSelection">
                                    <input
                                        type="radio"
                                        id={`${items.dosage}`}
                                        class="k-radio"
                                        value={items.dosage}
                                        name="dosageRadioButton"
                                        className="gen-ai-ims-home-content-k-radio popoverAvoidClickOutside"
                                        key={items.dosage + Math.random()}
                                        onChange={this.handleChangeInDosageType}
                                        checked={this.state.selectedDosage === items.dosage}
                                    />
                                    <div className="gen-ai-ims-home-dosagesText">{items.dosage}</div>
                                </div>
                            );
                        });
                }
                if (i === 6) {
                    return arrayOfDosage
                        .filter(
                            (val) => val.dosagetype === this.state.selectedDosageType[1]
                        )
                        .map((items, index) => {
                            return (
                                <div key={index} className="gen-ai-ims-home-dosagesSelection">
                                    <input
                                        type="radio"
                                        id={`${items.dosage}`}
                                        class="k-radio"
                                        value={items.dosage}
                                        name="dosageRadioButton"
                                        className="gen-ai-ims-home-content-k-radio popoverAvoidClickOutside"
                                        key={items.dosage + Math.random()}
                                        onChange={this.handleChangeInDosageType}
                                        checked={this.state.selectedDosage === items.dosage}

                                    />
                                    <div className="gen-ai-ims-home-dosagesText">{items.dosage}</div>
                                </div>
                            );
                        });
                }
            }
        }
    };
    handleChangeInDosageType = (event) => {
        event.preventDefault();
        if (event) {
            this.setState({
                selectedDosage: event.target.value,
                showDocsType: true,
            });
        }
    };
    generateDosageType = (dosageTypeArr) => {
        if (dosageTypeArr.length > 0) {
            return dosageTypeArr.map((items, index) => {
                return (
                    <div key={index} className="gen-ai-ims-home-dosagesTypes">
                        <span className="gen-ai-ims-home-dosagesTypes-title">{items}</span>
                        {this.generateListofDosageType(this.state.dosageType, index)}
                    </div>
                );
            });
        }
    };

    generateListOfDocTypes = (arrayOfDoc) => {
        if (arrayOfDoc.length > 0) {
            return arrayOfDoc.map((items, index) => {
                let url;
                if (this.state.selectedProduct !== "") {
                    url =
                        `/results?query=${this.state.selectedProduct}&q=All%20Fields&filters=` +
                        items.filter +
                        `&f1=tempJNJDrugs&fval1=${this.state.selectedProduct}&fcount=1&cspath=Copy Review Pieces-${items.title}&csproduct=${this.state.selectedProduct}`;
                } else {
                    url =
                        `/results?query=${this.state.selectedProduct}&q=All%20Fields&filters=` +
                        items.filter;
                }
                if (items.property === "parentLink")
                    return (
                        <div className="gen-ai-ims-home-modal-list-genAI-main-div">
                            <li key={index} className="modal-list-genAI">
                                <Link
                                    to={url}
                                    target="_blank"
                                    className="cs-modalLink"
                                    onClick={() =>
                                        this.handelDocsTypesLinks(items.filter, items.title)
                                    }
                                >
                                    <span className="gen-ai-ims-home-modal-list-title">{items.title}</span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </Link>
                            </li>
                        </div>
                    );
                else {
                    return (
                        <div className="gen-ai-ims-home-modal-list-genAI-main-div">
                            <li
                                key={index}
                                className="modal-list-genAI"
                            >
                                <Link
                                    to={url}
                                    target="_blank"
                                    className="cs-modalLink"
                                    onClick={() =>
                                        this.handelDocsTypesLinks(items.filter, items.title)
                                    }
                                >
                                    <span className="gen-ai-ims-home-modal-list-title">{items.title}</span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#EB1700" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </Link>
                            </li>
                        </div>
                    );
                }
            });
        }
    };
    handelDocsTypesLinks = (filter, url, title) => {
        const ts = new trackingService();
        // let newUrl = url.replaceAll('"', "'");
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            // "Link visited from Routes of Administration and Dosages tile",//+window.origin + newUrl,
            `Visited ${this.state.selectedProduct + " " + this.state.selectedDosage
            } for ${title}`,
            "",
            window.location.href,
            this.state.selectedProduct,
            filter,
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            `Routes of Administration and Dosages-${title}`,
            this.state.selectedProduct
        );
    };


    toggleExpandSectioncns = () => {
        this.setState({
            showContentDosage: !this.state.showContentDosage,
            showContentDocumentType: false,
            showNote: false,
        })
    }

    toggleExpandSectionDocumentType = () => {
        this.setState({
            showContentDosage: false,
            showContentDocumentType: !this.state.showContentDocumentType,
        })
    }

    handleCloseModal = () => {
        this.setState({ showCSModal: false, showDocsType: false, selectedDosage: "" }, () => {
            this.props.handelCRPCardDetail(this.state.showCSModal);
        });
    };

    handleCloseModalNote = () => {
        this.setState({
            showNote: false
        })
    }

    render() {
        return (
            <div className="GenAI-Recomm-ContentShortcutInnerWapper">
                {this.state.showCSModal && (
                    <>
                        <div
                            className="gen-ai-cs-modalHeader"
                            style={{
                                justifyContent: "center",
                                display: this.state.products.length <= 0 && "none",
                            }}
                        >
                            <select name="gen-ai-cs-product" id="gen-ai-cs-product" className="select-category popoverAvoidClickOutside" value={this.state.selectedProduct} onChange={(e) => this.handleSelectProduct(e)}
                            >
                                {this.productOptionListing()}
                            </select>
                            <div className="gen-ai-cs-popup-cancel-btn popoverAvoidClickOutside">
                                <span className="popoverAvoidClickOutside" onClick={this.handleCloseModal}>
                                    <svg width="18px" height="18px" className="popoverAvoidClickOutside" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                        <g id="SVGRepo_iconCarrier"> <title>cancel</title> <g id="Page-1" stroke-width="0.00512" fill="none" fill-rule="evenodd">
                                            <g id="work-case" fill="#afa7a7" transform="translate(91.520000, 91.520000)">
                                                <polygon id="Close" points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"> </polygon> </g> </g> </g></svg>
                                </span>
                            </div>
                        </div>
                        {this.state.showNote && <div className="gen-ai-ims-home-content-short-note-main-div">
                            <div className="gen-ai-ims-home-content-short-note-sub-main-div">
                                <div className="gen-ai-ims-home-content-short-note">
                                    PLEASE NOTE: The dosages provided below are those commonly searched by iMS users, so could include both approved and unapproved dosage forms as well as administered dosages. Please refer to your local Package Insert for the approved dosage forms and administered dosages.
                                </div>
                                <div className="gen-ai-ims-home-cs-popup-cancel-btn popoverAvoidClickOutside">
                                    <span className="popoverAvoidClickOutside" onClick={this.handleCloseModalNote}>
                                        <svg width="18px" height="18px" className="popoverAvoidClickOutside" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                            <g id="SVGRepo_iconCarrier"> <title>cancel</title> <g id="Page-1" stroke-width="0.00512" fill="none" fill-rule="evenodd">
                                                <g id="work-case" fill="#eb1700" transform="translate(91.520000, 91.520000)">
                                                    <polygon id="Close" points="328.96 30.2933333 298.666667 1.42108547e-14 164.48 134.4 30.2933333 1.42108547e-14 1.42108547e-14 30.2933333 134.4 164.48 1.42108547e-14 298.666667 30.2933333 328.96 164.48 194.56 298.666667 328.96 328.96 298.666667 194.56 164.48"> </polygon>
                                                </g>
                                            </g>
                                            </g>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                        </div>}
                        <div className="gen-ai-ims-home-contentshortcut-div">
                            <div className="gen-ai-ims-home-contentshortcut-inside-div-Admins-dosages">
                                <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
                                    <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                                        <span className="gen-ai-ims-home-contentshortcut-div-inside-span">Select Dosage</span>
                                        {this.state.showContentDosage ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectioncns} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                                            <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectioncns} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                                        }
                                    </div>
                                </div>
                                {this.state.showContentDosage && <div className="gen-ai-ims-home-modal-body-height-genAI">
                                    {this.state.dosageType.length ? <div className="cs-modalList gen-ai-cs-modalList">
                                        <ul style={{ listStyle: "none" }}>
                                            {this.generateDosageType(this.state.selectedDosageType)}
                                        </ul>
                                    </div> :
                                        <div className="dosageNA">
                                            This feature is not available for the product you selected.
                                        </div>
                                    }
                                </div>
                                }
                                {this.state.showDocsType && (<div><div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem">
                                    <div className="gen-ai-ims-home-contentshortcut-div-inside-menuItem-inside-div">
                                        <span className="gen-ai-ims-home-contentshortcut-div-inside-span">Document Type</span>
                                        {this.state.showContentDocumentType ? <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectionDocumentType} src={JJ_Icon_Chevron_down} alt="Loading Data" /> :
                                            <img className="gen-ai-ims-home-contentshortcut-div-inside-img" onClick={this.toggleExpandSectionDocumentType} src={JJ_Icon_Chevron_right} alt="Loading Data" />
                                        }
                                    </div>
                                </div>
                                    {
                                        this.state.showContentDocumentType && <div className="gen-ai-ims-home-modal-body-height-genAI">
                                            <div className="cs-modalList gen-ai-cs-modalList">
                                                <ul style={{ listStyle: "none" }}>
                                                    {this.generateListOfDocTypes(
                                                        this.state.arrayOfDocTypes)}
                                                </ul>
                                            </div>
                                        </div>
                                    }
                                </div>
                                )
                                }
                            </div>
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export default AdministrationAndDosagesGenAIRec;
